var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"small text-muted pl-4"},[_c('li',[_vm._v("中國信託/富邦銀行/玉山銀行/國泰世華帳戶免手續費")]),_c('li',[_vm._v("其它銀行帳戶手續費 15 元")])])
}]

export { render, staticRenderFns }